import React from 'react'
import { PropTypes } from 'prop-types'
import UniqId from 'uniqid'
import { withNamespaces } from "react-i18next"
import { compose } from 'redux'
import "./BedTypes.scss"

const BedTypes = props => {
  const { t } = props

  const bedTypeName = (code) => {
    const targetBedType = props.bedTypes.bed_type_options.find(bedType => bedType.code == code)
    return targetBedType ? targetBedType.name : null
  }

  return (
    <React.Fragment>
      {props.bedding.length > 0 &&
        <section>
          <h2>{ t('bed_type.title') }</h2>
          <ul styleName="bedtype-list">
            {props.bedTypes.bed_type_options.length > 0 ? props.bedding.map((bed) => {
              return <li styleName="bedtype-item" key={UniqId()}><span>{bedTypeName(bed.bed_type)}</span><span style={{ fontWeight: "bold" }} className="notranslate">{` ${bed.num}`}</span></li>
            }) : null}
          </ul>
        </section>
      }
    </React.Fragment>
  )
}

BedTypes.propTypes = {
  bedding: PropTypes.array.isRequired,
  bedTypes: PropTypes.array.isRequired
}

export default compose( withNamespaces('listings') )(BedTypes)
